import AssistPaymentDetails from './AssistPaymentDetails';
import FlightPaymentDetails from './FlightPaymentDetails';
import HotelPaymentDetails from './HotelPaymentDetails';
import WithRecargo from './WithRecargo';

const PaymentDetails = ({ cardData, productType, ...rest }) => {
  const hasRecargo = cardData?.recargo != null;

  if (hasRecargo) {
    return <WithRecargo cardData={cardData} />;
  }

  const COMPONENT_MAP = {
    assist: AssistPaymentDetails,
    flight: FlightPaymentDetails,
    hotel: HotelPaymentDetails,
  };

  const Component = COMPONENT_MAP[productType];

  return Component ? <Component {...rest} /> : null;
};

export default PaymentDetails;
